import React, { useEffect, useState } from 'react';
import { Card, CardBody } from '../other/card/card';
import ComponentLoader from '../other/ComponentLoader';
import googleLogo from '../../assets/services/google_logo.webp';
import bingLogo from '../../assets/services/bing_logo.webp';
import cyberlockerLogo from '../../assets/services/cyberlocker_logo.png';
import okruLogo from '../../assets/services/okru_logo.webp';
import dailymotionLogo from '../../assets/services/dailymotion_logo.webp';
import vimeoLogo from '../../assets/services/vimeo_logo.webp';
import telegramLogo from '../../assets/services/telegram_logo.png';
import { useGetPerServiceMonthlyDetailedQuery } from '../../redux/apis/analyticsManagement/aMAnalyticsApiSlice';

const services = {
    Google: {
        logo: googleLogo,
        name: 'Google',
    },
    Bing: {
        logo: bingLogo,
        name: 'Bing',
    },
    'ugc-source': {
        logo: cyberlockerLogo,
        name: 'Cyberlocker',
    },
    'Ok.ru': {
        logo: okruLogo,
        name: 'Ok.ru',
    },
    Dailymotion: {
        logo: dailymotionLogo,
        name: 'Dailymotion',
    },
    Vimeo: {
        logo: vimeoLogo,
        name: 'Vimeo',
    },
    Telegram: {
        logo: telegramLogo,
        name: 'Telegram',
    },
};

const ServiceCard = ({ title, reported_links, success_rate, photo }) => (
    <Card>
        <CardBody className="p-2 pt-4" style={{ minHeight: "210px", width: '100%', marginRight: "5px" }}>
            <div className="flex flex-col items-center mb-3">
                <img src={photo} alt={title} className="w-8 h-8" />
                <h5 className="mt-4 mb-2 font-size-15">{title.toUpperCase()}</h5>
                <p className="mb-0"><b>{reported_links}</b> Reported Links</p>
                <p className="mb-0"><b>{success_rate % 1 === 0 ? Math.round(success_rate) : success_rate}%</b> REMOVAL SUCCESS RATE</p>
            </div>
        </CardBody>
    </Card>
);

const ServicesData = ({ campaignId } = {}) => {
    const params = campaignId ? { campaign_id: campaignId } : undefined;
    const { data, isFetching } = useGetPerServiceMonthlyDetailedQuery(params);
    const [servicesInfo, setServicesInfo] = useState([]);

    useEffect(() => {
        if (!data) return;
        
        const updatedServicesInfo = Object.keys(services).map(service => ({
            title: services[service].name,
            reported_links: data[service.toLowerCase()]?.overall?.reported || 0,
            success_rate: data[service.toLowerCase()]?.overall?.success_rate || 0,
            photo: services[service].logo,
        }));

        setServicesInfo(updatedServicesInfo);
    }, [data]);

    const loadingCards = Object.entries(services).map(([key, value]) => (
        <ServiceCard key={key} title={key} reportedLinks={0} removalRate={0} photo={value} />
    ));

    return (
        <div className="col-xl-12 col-lg-6">
            <Card className="mb-3">
                <CardBody className="relative p-0">
                    {isFetching ? <ComponentLoader /> : null}
                    <div className='p-4'>
                        <div className="d-flex fw-bold small mb-3">
                            <span className="flex-grow-1">Platforms Insights</span>
                        </div>
                        <div className='flex flex-wrap justify-center gap-8'>
                            {data ? (
                                servicesInfo.map(item => (
                                    <ServiceCard key={item.title} {...item} />
                                ))
                            ) : loadingCards}
                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export default ServicesData;
